import { combineReducers } from 'redux'
import { createAction, createReducer, isActionOf } from 'typesafe-actions'
import { LOCATION_CHANGE, push } from 'connected-react-router'
import { flow } from 'fp-ts/es6/function'
import { snoc } from '../../utils/utils'
import { dropRight, last, takeRight } from 'fp-ts/es6/Array'
import { combineEpics } from 'redux-observable'
import { filter, map } from 'rxjs/operators'
import { getOrElse } from 'fp-ts/es6/Option'
import { userActions } from './user/user-actions'
import { RootEpic } from '../root'

export const actions = {
    goBack: createAction('@NAVIGATION/GO_BACK')<string>(),
}

export { actions as navigationActions }

export interface NavigationState {
    history: string[],
}

export const navigationReducer = combineReducers<NavigationState>({
    history: createReducer<string[]>([], {
        [LOCATION_CHANGE]: (state, action) => {
            return flow(
                snoc(action.payload.location.pathname),
                takeRight(50),
            )(state)
        }
    })
        .handleAction(actions.goBack, dropRight(2))
        .handleAction(userActions.logout.success, () => [])
})

const goBack: RootEpic = (action$, state$) => action$.pipe(
    filter(isActionOf(actions.goBack)),
    map(({ payload }) => {
        const history = state$.value.global.navigation.history
        return push(getOrElse(() => payload)(last(history)))
    })
)

export const navigationEpic = combineEpics(goBack)
